
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Constants } from '../../../common';
import { AuthService, CommonService, ThemeService } from '../../../services';
import { Router } from '@angular/router';
import { TermsComponent } from '../../terms';
import { PrivacyPolicyComponent } from '../../privacy-policy';
import { Permissions } from '../../../classes';
import { IprofileDialogueData } from '../../../models';

@Component({
    selector: 'app-profile-dialog',
    imports: [
    MatIconModule,
    MatButtonModule
],
    templateUrl: './profile-dialog.component.html',
    styleUrl: './profile-dialog.component.scss'
})
export class ProfileDialogComponent {

  applicationVersion: string = Constants.applicationVersion;
  isDarkMode = false;

  constructor(public dialogRef: MatDialogRef<ProfileDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: IprofileDialogueData, 
    private authService: AuthService, private router: Router, private dialog: MatDialog, private commonService: CommonService,
    private themeService: ThemeService) {
    this.isDarkMode = this.themeService.darkMode;
  }

  toggleDarkMode(): void {
    const userKey = this.commonService.currentUserProfile$.value?.email || this.commonService.profileDetail?.email || 'anonymous';
    this.isDarkMode = this.themeService.toggle(userKey);
  }

  openProfile(){
    // Implement edit profile logic
    this.dialogRef.close();
    this.commonService.openEditProfiledSideNav.next();
  }

  openAccountInfo(): void {
    // Implement account info logic
    this.dialogRef.close();
    this.router.navigate([Constants.routingPaths.accountInfo]);
  }

  changePassword(): void {
    // Implement change password logic
    this.dialogRef.close();
    this.commonService.openChangePasswordSideNav.next();
  }

  isSettingsVisible(){
    return Permissions.canView(Constants.screenNames.settings, this.commonService);
  }

  openSettings(): void {
    // Implement settings logic
    this.dialogRef.close();
    this.router.navigate([Constants.routingPaths.settings]);
  }

  logout(): void {
    // Implement logout logic
    this.dialogRef.close();
    this.authService.logout();
  }

    openTermsAndConditions(){
      this.dialog.open(TermsComponent, {
        maxWidth: '900px',
        panelClass: 'glass-dialog-container'
      });
    }
  
    openPrivacyPolicy(){
      this.dialog.open(PrivacyPolicyComponent, {
        maxWidth: '900px',
        panelClass: 'glass-dialog-container'
      });
    }
}
